module.exports = __webpack_public_path__ + "static/media/type-g.2b16b889.png";